import Vue from 'vue'
import Router from 'vue-router'
import Calendar from '@/views/Calendar'
import Login from '@/views/Login'
import Roles from '@/views/Roles'
import Summary from '@/views/Summary'
import Settings from '@/views/Settings'
import TimeLog from '@/views/TimeLog'
import Users from '@/views/Users'
import ResetPassword from '@/views/ResetPassword'
import store from '@/store'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/calendar',
      name: 'calendar',
      component: Calendar,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/reset-password/:token',
      component: ResetPassword,
      beforeEnter: (to, from, next) => {
        store.dispatch('logout')
        next()
      }
    },
    {
      path: '/roles',
      name: 'roles',
      component: Roles,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/summary',
      name: 'summary',
      component: Summary,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/time-log',
      name: 'time-log',
      component: TimeLog,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '*',
      name: 'default',
      component: TimeLog,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

export default router
